import React from 'react';
import type { Tenant } from '../services/api';

interface TenantCardProps {
  tenant: Tenant;
  isSelected: boolean;
  onClick: () => void;
}

const TenantCard: React.FC<TenantCardProps> = ({ tenant, isSelected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`p-4 rounded-lg border cursor-pointer transition-all ${
        isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-500'
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold text-gray-900">{tenant.name}</h3>
        <span className={`text-xs px-2 py-1 rounded-full ${
          tenant.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {tenant.status === 'active' ? '🟢 Aktif' : '⚪ Tidak Aktif'}
        </span>
      </div>
      <div className="text-sm text-gray-600 mb-1">{tenant.slug}</div>
      <div className="text-sm text-gray-500">{tenant.plan}</div>
      <div className="text-xs text-gray-400 mt-2">
        Midtrans: {tenant.midtrans_environment === 'production' ? 'Production' : 'Sandbox'}
      </div>
    </div>
  );
};

export default TenantCard;
